<template>
  <div :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications />

    <side-bar v-if="this.user.glpiactiveprofile != null">
      <sidebar-link
        v-if="management"
        to="/managementreports"
      >
        <md-icon>addchart</md-icon>
        <p>RELATÓRIOS GERENCIAIS</p>
      </sidebar-link>

      <sidebar-link to="/reports">
        <md-icon>dashboard</md-icon>
        <p>RELATÓRIOS</p>
      </sidebar-link>
      <sidebar-link to="/activities">
        <md-icon>label</md-icon>
        <p>GESTÃO DE OS</p>
      </sidebar-link>

      <sidebar-link
        v-if="management"
        to="/fte"
      >
        <md-icon>hourglass_full</md-icon>
        <p>FTE</p>
      </sidebar-link>

      <sidebar-link to="/equipments">
        <md-icon>list_alt</md-icon>
        <p>GESTÃO DE ATIVOS</p>
      </sidebar-link>

      <sidebar-link
        v-if="consumables"
        to="/consumables"
      >
        <md-icon>home_work</md-icon>
        <p>GESTÃO DE ESTOQUE</p>
      </sidebar-link>

      <sidebar-link
        v-if="knowbase"
        to="/knowbase"
      >
        <md-icon>inbox</md-icon>
        <p>BASE DE CONHECIMENTOS</p>
      </sidebar-link>

      <sidebar-link to="/cockpit">
        <md-icon>device_hub</md-icon>
        <p>ONLINE</p>
      </sidebar-link>
    </side-bar>

    <div class="main-panel">
      <TopNavbar />

      <dashboard-content style="background-color: #eeeeee" />

      <content-footer v-if="!$route.meta.hideFooter" />
    </div>
  </div>
</template>

<script>
import ms from "ms";

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";

import authService from "../../_services/auth.service";
import { userService } from "../../_services";
import { getUserSession } from "../../_services/localstorage";

import { isUserTechnician } from "../../util/is-user-technician";
import { isUserClient } from "../../util/is-user-client";

import { EventBus, events } from "../../_helpers/event-bus";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
  },
  data() {
    return {
      user: {
        username: "",
        name: "",
        firstName: "",
        lastName: "",
      },
      entities: [],
      triggers: [],
      alarmList: [],
      consumables: false,
      management: false,
      showFinance: false,
      knowbase: false,
    };
  },
  async created() {
    this.startLoading();
    this.user = await userService.info();

    if (!this.user || !this.user.token) {
      return authService.logout();
    }

    if (!isUserTechnician(this.user) && !isUserClient(this.user)) {
      this.management = true;
    }

    if (
      this.user.materialsPresentation &&
      this.user.materialsPresentation === "presented"
    ) {
      await this.checkConsumables();
    } else {
      this.consumables = false;
    }

    await this.checkKnowbase();
    await this.checkFinance();
    await this.getZabbixInfo();

    this.stopLoading();
    this.timers = [];
    this.timers.push(setInterval(this.loadData, ms("10 seconds")));
    this.timers.push(setInterval(this.updateToken, ms("5 minutes")));

    EventBus.$on(events.CHANGED_ENTITY, this.onEntityChange);
  },
  beforeDestroy() {
    this.timers.forEach((interval) => clearInterval(interval));
    EventBus.$off(events.CHANGED_ENTITY, this.onEntityChange);
  },
  methods: {
    startLoading() {
      this.$progress.start();
    },
    stopLoading() {
      this.$progress.stop();
    },
    shouldRequestZabbix() {
      return !this.$route.meta.ignoreZabbix;
    },
    loadData() {
      if (!this.shouldRequestZabbix()) {
        return;
      }

      //
      let i = 0,
        j = 0,
        count = 0;

      this.entities = JSON.parse(localStorage.getItem("sites"));

      if (this.entities && this.entities.length > 0) {
        //Get latest values
        userService
          .AsingZabbixProblems(this.entities)
          .then((zabbixProblems) => {
            if (this.entities.length > 0) {
              for (i = 0; i < this.entities.length; i++) {
                count = 0;
                for (j = 0; j < zabbixProblems.length; j++) {
                  if (
                    zabbixProblems[j].site === this.entities[i].site &&
                    zabbixProblems[j].acknowledged !== "SIM"
                  ) {
                    count = count + 1;
                    break;
                  }
                }
                this.entities[i].activeAlarm = count > 0;
              }
              localStorage.setItem("sites", JSON.stringify(this.entities));
            }
            this.alarmList = zabbixProblems;
          });
      }
    },
    updateToken() {
      if (!this.shouldRequestZabbix()) {
        return;
      }

      if (this.entities.length > 0) {
        userService.AsingUpdateZabbixToken(this.entities).then((apiData) => {
          this.entities = apiData.sites;
          this.triggers = apiData.triggers;
        });
      }
    },
    async checkFinance() {
      const { total } = await userService.searchTicketCost(this.user.token, 1);
      this.showFinance = total > 0;
    },
    async checkConsumables() {
      const { totalConsumableItem } = await userService.searchConsumableItemQuantity(this.user.token);
      this.consumables = totalConsumableItem > 0;
    },
    async checkKnowbase() {
      const entities = await userService.getObjectItem(
        "Entity",
        this.user.activeentity,
        "Document_Item",
        "?range=0-9990&get_hateoas=false",
      );
      this.knowbase = entities.some(entity =>
        entity.itemtype === "KnowbaseItem" ||
        entity.itemtype === "Entity"
      );
    },
    async getZabbixInfo() {
      if (!this.shouldRequestZabbix()) {
        return;
      }

      const apiData = await userService.AsingZabbixSiteInfo(this.user.token);
      this.entities = apiData.sites;
      this.triggers = apiData.triggers;
      this.countRespose = 0;
      this.processTicket = false;
      for (let i = 0; i < this.entities.length; i++) {
        await userService.AsingZabbixInfoBySite(this.entities[i]);
        this.countRespose++;
        if (this.countRespose === this.entities.length) {
          this.stopLoading();
        }
      }
    },
    async onEntityChange() {
      this.user = getUserSession();

      this.startLoading();

      await this.checkConsumables();
      await this.checkFinance();
      await this.checkKnowbase();

      await this.getZabbixInfo();

      this.stopLoading();
    },
  },
};
</script>

<style lang="scss">
.loading {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
}
.loader {
  left: 50%;
  margin-left: -4em;
  font-size: 10px;
  border: 0.8em solid rgba(218, 219, 223, 1);
  border-left: 0.8em solid rgba(58, 166, 165, 1);
  animation: spin 1.1s infinite linear;
}
.loader,
.loader:after {
  border-radius: 50%;
  width: 8em;
  height: 8em;
  display: block;
  position: absolute;
  top: 50%;
  margin-top: -4.05em;
}

@keyframes spin {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
